/**
 * Validates if a string contains HTML tags or script content
 * @param value - The string to validate
 * @returns true if HTML or script content is found, false otherwise
 */
export const containsHTMLOrScript = (value: string): boolean => {
  // Check for HTML tags (any content between < and >)
  const htmlTagRegex = /<[^>]*>/gi;
  // Check for script content (more comprehensive)
  const scriptRegex = /<script[\s\S]*?<\/script>/gi;
  const scriptAttributeRegex = /\s*on\w+\s*=/gi; // Event handlers like onclick, onload, etc.
  const javascriptProtocolRegex = /javascript:/gi;

  return (
    htmlTagRegex.test(value) ||
    scriptRegex.test(value) ||
    scriptAttributeRegex.test(value) ||
    javascriptProtocolRegex.test(value)
  );
};

export default containsHTMLOrScript;
